import ControlledFormField from "@/tpo/ControlledFormField";
import Stack from "@/tpo/Stack";
import { ToggleSwitchField } from "@/tpo/ToggleSwitch";
import { useWatch } from "react-hook-form";

import Box from "./Box";

export function shouldShowDutchTestQuestions(gender) {
  return gender === "Female";
}

export function DutchTestQuestionsFieldIfFemale({ gender: genderProp }) {
  const genderFromForm = useWatch({ name: "gender" });
  const gender = genderProp ?? genderFromForm;

  if (!shouldShowDutchTestQuestions(gender)) {
    return null;
  }

  return <DutchTestQuestionsField />;
}

export default function DutchTestQuestionsField() {
  return (
    <Stack bg="haze" p={[20, 20, 40]} gap={20}>
      <Box fontFamily="gilroyBold" fontSize={[16, 16, 18]} lineHeight={["24px", "24px", "28px"]}>
        Important additional information
      </Box>
      <ControlledFormField
        Component={ToggleSwitchField}
        name="birthControl"
        label="Currently taking any form of birth control?"
        display="flex"
        labelProps={{
          order: 2,
          m: 0,
          fontSize: [14, 14, 16]
        }}
        alignItems="center"
        gap={10}
      />
      <ControlledFormField
        Component={ToggleSwitchField}
        name="postMenopausal"
        label="Post menopausal?"
        display="flex"
        labelProps={{
          order: 2,
          m: 0,
          fontSize: [14, 14, 16]
        }}
        alignItems="center"
        gap={10}
      />
      <ControlledFormField
        Component={ToggleSwitchField}
        name="hrt"
        label="Currently taking HRT?"
        display="flex"
        labelProps={{
          order: 2,
          m: 0,
          fontSize: [14, 14, 16]
        }}
        alignItems="center"
        gap={10}
      />
    </Stack>
  );
}
